import { Link } from "react-router-dom";
import Logo from "./Logo";
import { LEGAL, CONTACT_EMAIL } from "../config/site";
import { MACROAREE } from "../content/services";

const STUDIO_LINKS = [
  { to: "/servizi", label: "Tutti i servizi" },
  { to: "/come-funziona", label: "Come funziona" },
  { to: "/richiedi-valutazione", label: "Richiedi una valutazione" },
];

const LEGAL_LINKS = [
  { to: "/privacy-policy", label: "Privacy Policy" },
  { to: "/cookie-policy", label: "Cookie Policy" },
  { to: "/informazioni", label: "Informazioni sul sito" },
];

export default function Footer() {
  const legalData = [
    LEGAL.titolare,
    LEGAL.piva && `P.IVA ${LEGAL.piva}`,
    LEGAL.collegio,
    LEGAL.pec && `PEC ${LEGAL.pec}`,
  ].filter(Boolean);

  return (
    <footer className="bg-antracite text-paper" data-testid="footer">
      <div className="container-site grid gap-12 py-14 md:grid-cols-[1.3fr_1fr_1fr] md:py-16">
        <div>
          <Logo variant="light" />
          <p className="mt-6 max-w-xs text-sm leading-relaxed text-paper/60">
            Pratiche tecniche, catastali, immobiliari e professionali gestite in tutta Italia.
          </p>
          <a
            href={`mailto:${CONTACT_EMAIL}`}
            data-testid="footer-email"
            className="mt-4 inline-block text-sm font-medium text-paper/80 underline-offset-4 transition-colors hover:text-paper hover:underline"
          >
            {CONTACT_EMAIL}
          </a>
        </div>
        <nav aria-label="Servizi">
          <p className="text-xs font-bold uppercase tracking-[0.22em] text-salvia">Servizi</p>
          <ul className="mt-5 space-y-2.5 text-sm">
            {MACROAREE.map((m) => (
              <li key={m.slug}>
                <Link
                  to={`/${m.slug}`}
                  data-testid={`footer-link-${m.slug}`}
                  className="text-paper/70 transition-colors hover:text-paper"
                >
                  {m.title}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <nav aria-label="Lo studio">
            <p className="text-xs font-bold uppercase tracking-[0.22em] text-salvia">Lo studio</p>
            <ul className="mt-5 space-y-2.5 text-sm">
              {STUDIO_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-link-${l.to}`} className="text-paper/70 transition-colors hover:text-paper">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
          <nav aria-label="Note legali">
            <p className="mt-8 text-xs font-bold uppercase tracking-[0.22em] text-salvia">Note legali</p>
            <ul className="mt-5 space-y-2.5 text-sm">
              {LEGAL_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} data-testid={`footer-legal-${l.to}`} className="text-paper/70 transition-colors hover:text-paper">
                    {l.label}
                  </Link>
                </li>
              ))}
            </ul>
          </nav>
        </div>
      </div>
      <div className="border-t border-white/10">
        <div className="container-site flex flex-col gap-2 py-6 text-xs text-paper/50 sm:flex-row sm:items-center sm:justify-between">
          <p data-testid="footer-copyright">© {new Date().getFullYear()} DN STUDIO TECNICO — Tutti i diritti riservati.</p>
          {legalData.length > 0 && <p data-testid="footer-legal-data">{legalData.join(" · ")}</p>}
        </div>
      </div>
    </footer>
  );
}
